import React, { useEffect, useState } from "react";
import LayoutHOC from "../LayoutHOC";

import { ReactComponent as ExpanIcon } from "../../assets/images/icons/expalndIcon.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import ToolTipComponent from "../UniversalComponents/ToolTipComponent";
import Customization from "../Customize/Customization";
import OnboardCompany from "../Onboarding/components/AddCompany/OnboardCompany";
import { useSidebar } from "../SidebarContext";
import EmailBuilderPage from "../EmailBuilder/EmailBuilderPage";
import DashBoardFunnel from "../Dashboard/DashBoardFunnel";
import GlobalListsDropdownTable from "../GlobalDropdown/GlobalListsDropdownTable";
import { getTitleCase } from "../../utils/utilityFunctions/stringUtility";
import GlobalTags from "../GlobalTags/GlobalTags";
import { ReactComponent as DownArrow } from "../../assets/images/downArrow.svg";
import FloatingElement from "../UniversalComponents/FloatingElement";

const SettingPage = () => {
  const { subset, subSubset: tabValue } = useParams();

  const navigate = useNavigate();
  const [collapsedGroups, setCollapsedGroups] = useState({});
  const [menuState, setMenuState] = useState({});
  const sidebarContext = useSidebar();
  const setheaderProps = sidebarContext?.setheaderProps;

  const [activeHoverItem, setActiveHoverItem] = useState(null);

  useEffect(() => {
    setheaderProps({ name: "Settings" });

    return () => {
      setheaderProps(null);
    };
  }, [setheaderProps]);

  const [expendedSide, setExpandedSide] = useState(false);

  useEffect(() => {
    if (!subset) {
      navigate(`/setting/${leftMenuStaticArray[0].value}`, { replace: true });
    }
  }, [subset, navigate]);

  //which component to render based on our selected item from left menu

  const componentList = {
    "general-info": OnboardCompany,
    "advanced-info": OnboardCompany,
    "group-or-users-permission": OnboardCompany,
    "manage-access": OnboardCompany,
    customization: Customization,
    "email-builder": EmailBuilderPage,
    dashboard_funnel: DashBoardFunnel,
    modules: Customization,
    "global-list": GlobalListsDropdownTable,
    "tag-list": GlobalTags,
  };

  const NotFound = () => <div className="p-4">Setting page not found.</div>;

  const ActiveComponent = componentList[tabValue] || componentList[subset] || NotFound;

  const leftMenuStaticArray = [
    {
      title: "General Info",
      icon: "bi bi-house-fill",
      value: "general-info",
      component: "CustomerHome",
    },
    {
      title: "Advanced Info",
      icon: "bi bi-layers-fill",
      value: "advanced-info",
      component: "CustomerHome",
    },
    {
      title: "Permission",
      icon: "bi bi-lock-fill",
      value: "group-or-users-permission",
      component: "CustomerHome",
    },
    {
      title: "Manage Access",
      icon: "bi bi-person-fill-lock",
      value: "manage-access",
      component: "CustomerHome",
    },
    {
      title: "Customization",
      icon: "bi bi-gear-wide-connected",
      value: "customization",
      // component: "CustomerHome",
      items: [
        { label: "Workspace & Templates", value: "modules", component: "modules" },
        { label: "Manage Dropdowns", value: "global-list", component: "global-list" },
        { label: "Manage Tags", value: "tag-list", component: "tag-list" },
      ],
    },
    {
      title: "Email Builder",
      icon: "bi bi-envelope-plus-fill",
      value: "email-builder",
      component: "CustomerHome",
    },
    {
      title: "Manage Funnel",
      icon: "bi bi-funnel-fill",
      value: "dashboard_funnel",
      component: "funnel",
    },
  ];

  const toggleGroup = (title) => {
    setCollapsedGroups((prev) => ({
      [title]: !prev[title],
    }));
  };

  const handleMenuToggle = (clickedItem) => {
    setMenuState((prev) => ({
      ...prev,
      [clickedItem.value]: !prev[clickedItem.value],
    }));
  };

  return (
    <div className="flex h-full gap-3">
      <div
        className={`bg-white border-b border-l border-r flex flex-col  shadow-[0px_2.667px_2.667px_rgba(0,0,0,0.05)] transition-[width] duration-200  ${expendedSide ? "min-w-[210px]" : "w-[50px]"} h-full`}
      >
        <div className="h-10 bg-primary-20 w-full flex justify-end items-center px-4 border-b ">
          <ExpanIcon
            width={"28px"}
            onClick={() => setExpandedSide((prev) => !prev)}
            className={`transition-transform duration-200 ${expendedSide ? "rotate-0" : "rotate-180"} cursor-pointer`}
          />
        </div>

        <div className="grow min-h-0 overflow-y-auto overflow-hidden  thinscrollbar bg-primary-active px-3 flex flex-col gap-y-2 pt-2">
          {leftMenuStaticArray?.map((section, index) =>
            expendedSide ? (
              <div key={index} className="last:border-none">
                <Link
                  className={`flex items-center justify-between px-3 py-2 tracking-wide cursor-pointer rounded-lg text-sm transition-colors duration-200
                    ${
                      section.value === subset
                        ? "text-white bg-primary font-600 hover:bg-primary hover:text-white"
                        : "hover:bg-primary-hover hover:text-primary text-[#667C8A] font-500"
                    }`}
                  onClick={() => toggleGroup(section.title)}
                  to={`/setting/${section.value}`}
                >
                  <div className="flex gap-2 items-center justify-between">
                    {" "}
                    {/* <section.icons width={"20px"} fill={section.value === tabValue ? "#365573" : "#667C8A98"} /> */}
                    <i className={`${section.icon} text-xl transition-colors duration-200`} />
                    <span className="">{section.title}</span>
                  </div>
                  {section.items && (
                    <span
                      className={`self-center ml-4 mr-2 transition-transform duration-200 ${
                        collapsedGroups[section.title] ? "rotate-180 text-[#383838CC]" : "rotate-0 text-[#666] "
                      }`}
                      // onClick={(e) => {e.stopPropagation(); toggleGroup(section.title)}}
                    >
                      <DownArrow fill={section.value === subset ? "#ffffff" : "#667C8A98"} />
                    </span>
                  )}
                </Link>

                {section.items && collapsedGroups[section.title] && (
                  <div className="flex flex-col ml-5">
                    {section.items
                      .filter((item) => !item.checkAccess || item.access)
                      .map((tab, i) => (
                        <div key={i} className="relative ">
                          <Link
                            className={`flex items-center gap-2  py-2  px-3 cursor-pointer text-sm   border-l-2 rounded-r-md
                                                ${
                                                  subset === tab.value && section.value === tabValue
                                                    ? "bg-primary-active text-[#666] font-500 border-primary "
                                                    : "text-[#666] font-400 border-[#D2DAE1] hover:bg-primary-hover"
                                                }`}
                            to={`/setting/${section.value}/${tab.value}`}
                            onClick={() => handleMenuToggle(tab)}
                            role="tab"
                          >
                            <div className="flex justify-between">
                              <p
                                className={`whitespace-nowrap flex items-center gap-2 ${
                                  subset === tab.value && section.value === tabValue
                                    ? "text-primary font-semibold "
                                    : "text-[#666] font-normal"
                                }`}
                              >
                                {getTitleCase(tab.label)}
                              </p>
                            </div>
                          </Link>
                        </div>
                      ))}
                  </div>
                )}
              </div>
            ) : (
              <div
                key={index}
                className="last:border-none w-full"
                onMouseEnter={() => setActiveHoverItem(section.value)}
                onMouseLeave={() => setActiveHoverItem(null)}
              >
                <ToolTipComponent text={section.title} placement="right" darkMode>
                  <Link
                    className={`flex items-center justify-center text-base font-500 tracking-wide cursor-pointer  
              `}
                    to={`/setting/${section.value}`}
                    onClick={() => toggleGroup(section.title)}
                  >
                    <i
                      className={`${section.icon} flex items-center justify-center text-xl p-2 rounded-md transition-colors duration-200 ${
                        section.value === subset
                          ? "text-[#fff] bg-primary hover:bg-primary hover:text-[#fff]"
                          : "text-[#667C8A99] hover:bg-primary-hover hover:text-primary"
                      }`}
                    />
                  </Link>
                </ToolTipComponent>
                {section.items && section.value === activeHoverItem && (
                  <div className={`h-[110px]`}>
                    <FloatingElement xMargin={-30}>
                      <div className="flex flex-col w-fit bg-primary-active rounded-md">
                        {section.items
                          .filter((item) => !item.checkAccess || item.access)
                          .map((tab, i) => (
                            <div
                              key={i}
                              className={`relative flex items-end ${section.items.length - 1 === i ? "mb-2" : "mb-0"}`}
                            >
                              {section.items.length - 1 === i ? (
                                <svg
                                  width="26"
                                  className="h-10"
                                  height="50"
                                  viewBox="0 0 26 50"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M6 0 L6 25 Q6 40 30 35"
                                    stroke="var(--color-primary-50)"
                                    strokeWidth="2"
                                    fill="none"
                                    strokeLinecap="round"
                                  />
                                </svg>
                              ) : (
                                <svg
                                  width="26"
                                  height="50"
                                  className="h-10"
                                  viewBox="0 0 26 50"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M6 0 L6 50"
                                    stroke="var(--color-primary-50)"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                  />
                                  <path
                                    d="M6 25 Q6 40 30 35"
                                    stroke="var(--color-primary-50)"
                                    strokeWidth="2"
                                    fill="none"
                                    strokeLinecap="round"
                                  />
                                </svg>
                              )}

                              <Link
                                className={`flex items-center gap-2  px-1 py-1 cursor-pointer text-sm  rounded mr-2 
                                                ${
                                                  subset === tab.value && section.value === tabValue
                                                    ? "bg-primary-active text-[#666] font-500 border-primary "
                                                    : "text-[#666] font-400 border-[#D2DAE1] hover:bg-primary-hover"
                                                }`}
                                to={`/setting/${section.value}/${tab.value}`}
                                onClick={() => handleMenuToggle(tab)}
                                role="tab"
                              >
                                <div className="flex justify-between">
                                  <p
                                    className={`whitespace-nowrap flex items-center gap-2 ${
                                      subset === tab.value && section.value === tabValue
                                        ? "text-primary font-semibold "
                                        : "text-[#666] font-normal"
                                    }`}
                                  >
                                    {getTitleCase(tab.label)}
                                  </p>
                                </div>
                              </Link>
                            </div>
                          ))}
                      </div>
                    </FloatingElement>
                  </div>
                )}
              </div>
            )
          )}
        </div>
      </div>
      <div className="min-w-0 grow">
        <ActiveComponent />
      </div>
    </div>
  );
};

export default LayoutHOC(SettingPage);
